import { ref, computed } from 'vue'

// [
//     {
//         "id": 9,
//         "user": 1,
//         "machine_id": "aa1",
//         "processing_software_version": "matlab1.0",
//         "created": "2024-07-02T15:35:34.044413Z",
//         "updated": "2024-07-02T15:35:34.044413Z"
//     }
// ]
export interface Worker {
  id?: number
  user: number
  machine_id: string
  processing_software_version: string
  created: string

  [key: string]: string | number | object | string[] | null | undefined
}

export function useWorkers() {
  const workers = ref<Worker[]>([]) // items is now Ref<Item[]>
  const getItems = async (): Promise<Worker[]> => {
    const response = await fetch('/api/workers/')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Advances')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchItems = async () => {
    workers.value = await getItems()
  }

  const workerKeys = computed(() => {
    const keys = workers.value.length > 0 ? Object.keys(workers.value[0]) : []
    // remove created and updated keys
    keys.splice(keys.indexOf('created'), 1)
    keys.splice(keys.indexOf('updated'), 1)
    return keys
  })

  return { workers, fetchItems, workerKeys }
}
